import styled from "styled-components";
import { Col, Divider, Row } from "antd";
import { HeaderSection } from "../../Cards";
import { useState } from "react";
import { RAButtonPrimary, RATextInput } from "@/components/customs";
import { isEmpty } from "lodash";
import { activateUserPassword } from "@/stores/apis/apiAuth";
import { toast } from "@/modules/toast";
import { NOTIFICATION_TYPE, REGEX_PASSWORD } from "@/config/constants";
import { ModalStatus } from "../../Modals";
import { useRouter } from "next/router";

export function ComponentActivateAccount() {
	const router = useRouter();
	const [formPassword, setFormPassword] = useState({
		password: "",
		passwordConfirm: "",
	});
	const [error, setError] = useState({});
	const [loading, setLoading] = useState(false);
	const [showStatus, setShowStatus] = useState(false);

	const validatePassword = () => {
		let valid = true;
		let errs = {};
		const regrex = new RegExp(REGEX_PASSWORD);
		if (!formPassword.password || !formPassword.password.trim()) {
			errs.password = "Please enter your new password.";
		} else if (!regrex.test(formPassword.password)) {
			errs.password =
				"Password must contain at least 8 characters, at least one uppercase letter, one lowercase letter, one number and special character.";
		}
		if (!formPassword.passwordConfirm || !formPassword.passwordConfirm.trim()) {
			errs.passwordConfirm = "Please enter confirm password.";
		}
		if (
			formPassword.password &&
			formPassword.passwordConfirm &&
			formPassword.password !== formPassword.passwordConfirm
		) {
			errs.passwordConfirm = "Confirm password incorrect.";
		}

		if (!isEmpty(errs)) {
			valid = false;
			setError(errs);
		}

		return valid;
	};

	const onSubmitChangePassword = async () => {
		const valid = validatePassword();
		if (!valid) return;

		setLoading(true);

		const payload = {
			password: formPassword.password,
			token: router.query?.token,
		};
		const response = await activateUserPassword(payload);
		if (response) {
			setShowStatus(true);
		} else {
			toast({
				type: NOTIFICATION_TYPE.ERROR,
				description: "Something went wrong. Please try again later.",
			});
		}

		setTimeout(() => {
			setLoading(false);
		}, 300);
	};

	return (
		<Container>
			<BodyContainer>
				<HeaderSection
					title="Create Your Password"
					description="Please enter your password so you can use it for your next login"
				/>
				<Divider />
				<Row gutter={[10, 20]}>
					<Col span={24}>
						<RATextInput
							title="New Password"
							value={formPassword.password}
							onChange={(val) => {
								setFormPassword({
									...formPassword,
									password: val,
								});
								setError({});
							}}
							placeholder=" "
							error={error.password || null}
							type="password"
						/>
					</Col>
					<Col span={24}>
						<RATextInput
							title="Confirm Password"
							value={formPassword.passwordConfirm}
							onChange={(val) => {
								setFormPassword({
									...formPassword,
									passwordConfirm: val,
								});
								setError({});
							}}
							placeholder=" "
							error={error.passwordConfirm || null}
							type="password"
						/>
					</Col>
					<Col
						span={24}
						style={{
							marginTop: "12px",
							display: "flex",
							justifyContent: "center",
						}}
					>
						<RAButtonPrimary title="SUBMIT" onClick={() => onSubmitChangePassword()} loading={loading} />
					</Col>
				</Row>
			</BodyContainer>

			{/* modals */}
			<ModalStatus
				visible={showStatus}
				title="Password Created Successfully!"
				note="You can use it for your next login"
				onClose={() => {
					setShowStatus(false);
					router.push("/");
				}}
			/>
		</Container>
	);
}

const Container = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	min-height: 100vh;

	@media (max-width: 767px) {
		padding: 0 40px;
	}
	@media (max-width: 575px) {
		padding: 0 20px;
	}
`;
const BodyContainer = styled.div`
	max-width: 768px;
	width: 100%;
	border-radius: 16px;
	border: 1px solid var(--bg-500-line, #e9e8e8);
	padding: 60px;
	margin-top: 120px;

	&.home-utilities-container-outer {
		margin-top: 50px;
	}
	@media (max-width: 991px) {
		padding: 40px;
		&.home-utilities-container-outer {
			margin-top: 30px;
		}
	}
	@media (max-width: 767px) {
		padding: 30px;
		&.home-utilities-container-outer {
			margin-top: 20px;
		}
	}
	@media (max-width: 575px) {
		padding: 20px;
		&.home-utilities-container-outer {
			margin-top: 12px;
		}
	}
`;
